import React, { useEffect, useState, useRef } from 'react';
//inview
import { useInView } from 'react-intersection-observer';
//stores
import useAdminStore from "src/webapp/stores/admin.store";
//hook
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcList.module.scss';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import ActiveButtonWrapper from 'src/webapp/views/wrapper/ActiveButtonWrapper';
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Search from './Search';//검색
import List from './List';//정산내역목록
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인

export default function PartnerCalcList() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { setOnMessageHandler } = useComnHook();
    //stores
    const { admin } = useAdminStore();
    
    const isLock = useRef(false);//더블클릭방지Ref
    const searchRef = useRef([]);//검색어
    const scrollRef = useRef();//elementScroll관리Ref
    
    /* ==================== 파트너정산내역리스트 ==================== */
    const pageRef = useRef(20);//infinityObserver페이지DOMRef
    const [ partnerCalcList, setPartnerCalcList ] = useState([]);
    const partnerCalcListAPI = async (type) => {//0:무한로드, 1:검색 
        if((type === 0 && pageRef.current == null) || isLock.current) { return; }
        
        isLock.current = true;
        pageRef.current = (type === 0 ? pageRef.current : 20);
        const DATA = { PARTNER_NAME: searchRef.current[1].value, START_DT:searchRef.current[2]?.value.replaceAll("-", ""), END_DT:searchRef.current[3]?.value.replaceAll("-", ""), ROWNUM:pageRef.current };
        const result = await axiosPostHandler(`partnerCalcListForAdmin.do`, DATA);
        setTimeout(() => { isLock.current = false; }, 500);
        if(!result) { return; }
        if(result.message === "INVALID_DATA") {
            if (pageRef.current === 20) { setPartnerCalcList([]); }
            pageRef.current = null;
        }
        if(result.message === "SUCCESS") {
            setPartnerCalcList(pageRef.current === 20 ? result.data : partnerCalcList.concat(result.data));
            pageRef.current = result.data.length < 20 ? null : pageRef.current + 20;
            if (type === 1) {//스크롤 최상단으로 올리기
                scrollRef.current?.scrollIntoView({ behavior: 'instant' });
            }
        }
    }
    useEffect(() => {
        partnerCalcListAPI(0);//파트너정산내역리스트API
    }, []);
    //infinityObserver
    const [inViewRef, inView] = useInView({ behavior: 'smooth', threshold: .5 });
    useEffect(() => {
        if(inView && (pageRef.current != null)) { partnerCalcListAPI(0); }//파트너정산내역리스트API
    }, [inView]);
    /* ==================== 파트너정산내역리스트 ==================== */
    /* ==================== 정산승인처리 ==================== */
    const [ checkedCalcList, setCheckedCalcList ] = useState([]);
    const partnerCalcUpdateAPI = async (type) => {//type - 1.선택정산, 2.전체정산
        if(isLock.current || !window.confirm("승인 후에는 다시 복구할 수 없습니다.\n승인하시겠습니까?")) { return; }
        
        isLock.current = true;
        let DATA = [];
        if(type === 1) {
            for(let i = 0; checkedCalcList.length > i; i++) {
                DATA.push({ SEQ_NO:checkedCalcList[i].SEQ_NO, SUBMIT_TYPE:type, CALC_YN:'Y', LAST_UPDATE_USER:admin.COMN_ID });
            }
        }
        if(type === 2) {
            DATA = [{ START_DT:searchRef.current[2]?.value.replaceAll("-", ""), END_DT:searchRef.current[3]?.value.replaceAll("-", ""), SUBMIT_TYPE:type, CALC_YN:'Y', LAST_UPDATE_USER:admin.COMN_ID }];
        }
        const result = await axiosPostHandler(`partnerCalcUpdateArrayForAdmin.do`, DATA);
        setTimeout(() => { isLock.current = false; }, 500);
        if(!result || result.message !== "SUCCESS") { setOnMessageHandler(2, "승인이 실패하였습니다.\n잠시후 다시 시도해주시기 바랍니다."); }
        if(result.message === "SUCCESS") {
            setOnMessageHandler(1, "정상 승인이 완료되었습니다.");
            let newList = [];
            partnerCalcList.filter((item) => { 
                if(type === 1) {
                    if(checkedCalcList.includes(item)) {
                        item['CALC_YN'] = 'Y';
                    }
                }
                if(type === 2) {
                    item['CALC_YN'] = 'Y';
                }
                newList.push(item); 
            });
            setCheckedCalcList([]);
            setPartnerCalcList(newList);
        }
    }
    /* ==================== 정산승인처리 ==================== */

    return (
        <>
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`정산 내역`} dept={[{ label: '정산 관리' }, { label: '정산 내역' }]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FixedPanel>
                    <Element tag={`div`} className={styles.searchWrap}>
                        <Search search={searchRef} onSearch={partnerCalcListAPI} />
                        <ActiveButtonWrapper>
                            <Element tag={`div`}>
                                {admin.LEVEL <= 2 ? <button disabled={checkedCalcList.length <= 0 ? true : false} onClick={(e) => partnerCalcUpdateAPI(1)}><span>선택 승인</span></button> : null}
                                {admin.LEVEL <= 2 ? <button disabled={partnerCalcList.legnth <= 0 ? true : false}onClick={(e) => partnerCalcUpdateAPI(2)}><span>일괄 승인</span></button> : null}
                            </Element>
                        </ActiveButtonWrapper>
                    </Element>
                </FixedPanel>
                <FlickPanel>
                    <Element tag={`div`} className="fullHeight" propRef={el => (scrollRef.current = el)}>
                        <List list={partnerCalcList} checkedList={checkedCalcList} setCheckedList={setCheckedCalcList} />
                        {partnerCalcList.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                        : partnerCalcList.length > 0 && pageRef.current === null ? <InViewData readAll={true} />
                        : null}
                    </Element>
                </FlickPanel>
            </Container>
        </Section>
        </>
    );
}